import React from 'react'
import moment from 'moment'
import { array } from 'helpers'
import cx from 'classnames'

import { Grid, Cell } from 'components/layout/grid'

import s from './WeekDays.scss'


const weekDays = moment.weekdaysShort(true)

const WeekDays = ({ gutter, onWeekDayClick }) => (
  <Grid className={s.weekDays} columns={7} gutter={gutter}>
    {
      array.range(0, 6).map((dayOfWeek) => (
        <Cell
          key={dayOfWeek}
          className={cx(s.weekDay, {
            // [s.selectedWeekDay]: selectedWeekDay === dayOfWeek,
          })}
          size={1}
          onClick={() => onWeekDayClick(dayOfWeek)}
        >
          {weekDays[dayOfWeek]}
        </Cell>
      ))
    }
  </Grid>
)



export default WeekDays
